import React, { useState } from "react";
import LockIcon2 from "../../../../../components/icons/LockIcon2";
import RoundTrueIcon from "../../../../../components/icons/RoundTrueIcon";
import "./TemplateList.scss";
import StandardTemplatesList from "./StandardTemplatesList";
import ProTemplatesList from "./ProTemplatesList";
import { AuthHelpers } from "../../../../../utils/auth.helpers";
import AgencyPersonalizedTemplatesList from "./AgencyPersonalizedTemplatesList";

const SelectTemplateList = ({
  selectedDesignTemplateId,
  selectedAnnouncementSlug,
  selectedDesignTemplateStageSlug,
  postType,
  onSelectTemplate,
}: {
  selectedDesignTemplateId: string;
  selectedDesignTemplateStageSlug?: string;
  selectedAnnouncementSlug?: string;
  postType: string;
   onSelectTemplate: (data: any) => void;
}) => {
  const [state, setState] = useState({
    selectedId: "1",
  });
  let is_agent_check = AuthHelpers?.agentCheck();

  const onClickSelect = (id: string) => {
    setState({
      ...state,
      selectedId: id,
    });
  };

  const selectTemplateTab = [
    {
      id: "1",
      title: "Standard designs",
      active: false,
    },
    {
      id: "2",
      title: "Brand designs",
      active: false,
    },
    {
      id: "3",
      title: "Personalized designs",
      active: false,
    },
  ];

  return (
    <div className="select-template-list-container">
      {/* <div className="select-template-top-head">
        <p>Select Template</p>
      </div> */}

      <div className="select-template-scroll-area">
        <div className="select-template-tab-contain">
          {selectTemplateTab?.map((data) => (
            <button
              className={`tab-btn ${data?.id === state?.selectedId ? "tab-button-active" : ""}`}
              key={data?.id}
              onClick={() => onClickSelect(data?.id)}
            >
              {data?.title}
            </button>
          ))}
        </div>
      </div>
      {/* <div className="template-tab-divider"></div> */}

      <div className="template-list-content">
        {state.selectedId === "1" ? (
          <StandardTemplatesList
            selectedId={selectedDesignTemplateId}
            selectedAnnouncementSlug={selectedAnnouncementSlug}
            selectedDesignTemplateStageSlug={selectedDesignTemplateStageSlug}
            postType={postType}
            onSelectTemplate={onSelectTemplate}
          />
        ) : state.selectedId === "2" ? (
          <ProTemplatesList
            selectedId={selectedDesignTemplateId}
            selectedAnnouncementSlug={selectedAnnouncementSlug}
            postType={postType}
          />
        ) : (
          // <AgencyPersonalizedTemplatesList
          //   selectedId={selectedDesignTemplateId}
          //   selectedAnnouncementSlug={selectedAnnouncementSlug}
          // />
          // <ProTemplatesList
          //   selectedId={selectedDesignTemplateId}
          //   selectedAnnouncementSlug={selectedAnnouncementSlug}
          // />
          <AgencyPersonalizedTemplatesList
            selectedId={selectedDesignTemplateId}
            selectedAnnouncementSlug={selectedAnnouncementSlug}
            postType={postType}
          />
        )}
      </div>
    </div>
  );
};

export default SelectTemplateList;
